export default "__VITE_ASSET__CTqkeT2r__"